let branch, BranchEvent;
let branchWebInitialized = false;

import { Platform } from "react-native";

if (Platform.OS !== "web") {
  branch = require("react-native-branch").default;
  BranchEvent = require("react-native-branch").BranchEvent;
} else {
  branch = require("branch-sdk");
}

branch.initSessionTtl = 10000;

const safeBranchMethod = async (methodName, fallback = {}) => {
  try {
    if (Platform.OS === "web" && !branchWebInitialized) {
      return fallback;
    }
    if (typeof branch?.[methodName] !== "function") {
      return fallback;
    }
    return await branch[methodName]();
  } catch (err) {
    console.warn(`Branch ${methodName} failed:`, err);
    return fallback;
  }
};

export const initBranch = async () => {
  if (Platform.OS === "web") {
    return new Promise((resolve) => {
      try {
        branch.init(
          "key_live_jlJxdDWKXKSgKXpBRnv3uhkpyrpjZfim",
          function (err, data) {
            if (err) {
              console.warn("Branch init failed:", err);
              branchWebInitialized = false;
              resolve({});
            } else {
              branchWebInitialized = true;
              resolve(data?.data_parsed || {});
            }
          }
        );
      } catch (err) {
        console.warn("Branch init failed:", err);
        resolve({});
      }
    });
  } else {
    const params = await safeBranchMethod("getFirstReferringParams");

    // Alert.alert("first params", JSON.stringify(params));
    let lastParams = await safeBranchMethod("getLatestReferringParams");
    // Alert.alert("last params", JSON.stringify(lastParams));
    return params;
  }
};

const branchProxy = new Proxy(branch, {
  get(target, prop) {
    if (
      Platform.OS === "web" &&
      ["getFirstReferringParams", "getLatestReferringParams"].includes(prop)
    ) {
      return () => safeBranchMethod(prop);
    }
    return target[prop];
  },
});

export default branchProxy;
// export BranchEvent;
